import cn from 'classnames';
import React from 'react';

import AppPopup from '../Popup/AppPopup';
import {CircleLoader} from './CircleLoader';

const AppLoader = ({isTransparent}) => {
    const overlayStyles = cn('fixed inset-0 z-[250] bg-color bg-color-secondary dark:bg-color-dark-gray', {
        'opacity-50': isTransparent,
    });

    return (
        <AppPopup
            isOpen
            isCloseVisible={false}
            className='absolute bottom-0 left-0 right-0 top-0 z-[150] mx-auto flex h-full w-full max-w-md  flex-col items-center justify-center focus:outline-none'
            overlayClassName={overlayStyles}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <CircleLoader />
        </AppPopup>
    );
};

export default AppLoader;
